import styled from "@emotion/styled";
import HistoryTableDesktop from "./HistoryTableDesktop";
import HistoryChart from "./HistoryChart";
import NavigationButton from "../../elements/NavigationButton";
import { CommonButtonDiv } from "../../elements/Buttons";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import NoDataStub from "../../elements/NoDataStub";
import HistoryTableMobile from "./HistoryTableMobile";
import t from "../../../../helper/t";
import { startMeasurement3 } from "../../measurement/startMeasurement3";
import WhiteContainer from "../WhiteContainer";
import CommonContainer from "../../elements/CommonContainer";

const RootDiv = styled.div(({ theme }) => ([
    {
        display: "flex",
        flexDirection: "column",
    }
]));

const BaseContainer = styled(CommonContainer)(({ theme }) => ([
    theme.splus3.background.primary,
    {
        paddingLeft: 20,
        paddingRight: 20,

        /* for mobile */
        [theme.splus3.breakpoints.mobile]: [
            {
                paddingLeft: 0,
                paddingRight: 0,
            }
        ],
    }
]));

const TableContainer = styled(BaseContainer)([
    {
        paddingTop: 24,
        paddingBottom: 24,
        maxHeight: 478,
        overflowY: "scroll",
    }
]);

const CaptionDiv = styled.div(({ theme }) => ([
    theme.splus3.foreground.text,
    theme.splus3.typography.font24Bold,
    {
        marginTop: 40,
        paddingLeft: 24,
        paddingRight: 20,
        paddingTop: 24,
        paddingBottom: 16,

        /* for mobile */
        [theme.splus3.breakpoints.mobile]: [
            {
                marginTop: 0,
            }
        ],
    }
]));

const ChartContainer = styled(BaseContainer)(({ theme }) => ([
    {
        paddingTop: 16,
        paddingBottom: 32,

        /* for mobile */
        [theme.splus3.breakpoints.mobile]: [
            {
                paddingLeft: 16,
                paddingRight: 16,
            }
        ],
    }
]));

const ButtonContainer = styled.div(({ theme }) => ([
    {
        marginTop: 24,
        marginBottom: 48,
        marginLeft: "auto",
        marginRight: "auto",
    }
]));

export const StartButtonDiv = styled(CommonButtonDiv)(
    {
        paddingLeft: 30,
        paddingRight: 30,
        minWidth: 0,
    }
);

interface HistoryProps {
}

const History: React.FC<HistoryProps> = ({ }) => {
    const dispatch = useAppDispatch();
    const historyState = useAppSelector(state => state.history);

    return (
        <RootDiv>
            {historyState.records.length === 0 ?
                <NoDataStub /> :
                <>
                    <TableContainer>
                        <HistoryTableDesktop />
                        <HistoryTableMobile />
                    </TableContainer>
                    <WhiteContainer>
                        <CaptionDiv>{t("Vergleich der Testergebnisse")}</CaptionDiv>
                    </WhiteContainer>                    
                    <ChartContainer>
                        <HistoryChart />
                    </ChartContainer>
                </>
            }
            <WhiteContainer style={{ display: "flex", flexDirection: "column" }}>
                <ButtonContainer>
                    <NavigationButton onClick={() => {
                        dispatch(startMeasurement3());
                    }}>
                        <StartButtonDiv>
                            {t("Speedtest erneut starten")}
                        </StartButtonDiv>
                    </NavigationButton>
                </ButtonContainer>
            </WhiteContainer>
        </RootDiv>
    );
}

export default History;
